<div modalHeader class="modal-header py-2">
  <h2 class="mb-0">Chat with {{party?.name}}</h2>
  <tr-icon [icon]="icon.cancel" classes="ml-auto py-1 px-2" (click)="cancel()"></tr-icon>
</div>

<div modalContent class="modal-body">
  <ul *ngIf="filteredMessages.length" class="list-unstyled mb-1 d-flex flex-column-reverse messages-list">
    <li *ngFor="let msg of filteredMessages" class="mb-3">
      <div class="d-flex flex-nowrap pt-1">
        <div class="col-4">
          <span *ngIf="msg?.Body">
            <span class="btn btn-info btn-tel bi bi-person-fill mr-2"></span><strong>{{party?.name || party?.carrier}}</strong>
          </span>
          <span *ngIf="msg?.message" class="d-flex flex-row align-items-center">
            <button class="btn btn-info btn-tel mr-2">{{location.name.substring(0, 1) | titlecase}}</button><strong>You</strong>
          </span>
        </div>
        <div class="message-body w-100">
          <span [innerHTML]="msg?.Body || msg?.message"></span><br/>
          <small>{{msg?.status_sent || 'received'}} | {{ msg?.time | trDateFormat:'M/D h:mm a':location.timezone}}</small>
        </div>
      </div>
    </li>
  </ul>

  <form *ngIf="showReplyForm" role="form" [formGroup]="form" novalidate>
    <div class="form-group">
      <label for="sms-reply" class="control-label">Reply</label>
      <textarea
        id="sms-reply"
        name="smsResp"
        type="text"
        rows="4"
        class="w-100"
        minlength="1"
        required
        noWhitespace
        text-watcher
        bitly
        formControlName="smsReply"
        [maxlength]="maxLength"
        [ngClass]="{'is-invalid': smsReplyControl.touched && smsReplyControl.invalid}"
      ></textarea>
      <sms-warning [message]="smsReplyControl.value"></sms-warning>
      <chat-counter [maxAnsiChars]="maxAnsiLength" [maxNonAnsiChars]="maxNonAnsiLength" [chats]="smsReplyControl.value"></chat-counter>
      <control-messages [control]="smsReplyControl"></control-messages>
    </div>

    <div *ngIf="showTemplates && templates.length" class="row" [class.dropdown-opened]="dropDownOpened">
      <div class="col form-group">
        <frontend-dropdown
          elementId="saved-templates"
          class="w-100"
          [items]="templates"
          [multiple]="false"
          bindLabel="name"
          bindValue="id"
          placeholder="Choose saved reply"
          formControlName="replyTemplate"
          [customName]="savedReplyText"
          [customOptionHtml]="savedReplyOptionText"
          [maxListHeight]="'7rem'"
          [wrapItemText]="true"
          (popoverOpen)="onDropdownTriggered(true)"
          (popoverClose)="onDropdownTriggered(false)"
        ></frontend-dropdown>
      </div>
    </div>
  </form>
</div>

<div modalFooter class="modal-footer">
  <div class="d-flex flex-row align-items-center justify-content-end">
    <button
      type="button"
      (click)="sendSMS()"
      class="btn btn-info mr-2"
      [disabled]="form.pristine || form.invalid"
      angularticsCategory="waitlist"
      angulartics2On="click"
      angularticsAction="sent SMS chat"
    >Send SMS</button>
    <button
      type="button"
      (click)="cancel()"
      angularticsCategory="waitlist"
      angulartics2On="click"
      angularticsAction="Close Chat Modal"
      class="btn btn-danger"
    >Cancel</button>
  </div>
</div>
